import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveVideoComponent } from '../live-video/live-video.component';
import { SafePipeModule } from '../../pipes';

@NgModule({
    imports: [
        CommonModule,
        SafePipeModule,
    ],
    exports: [ LiveVideoComponent  ],
    declarations: [ LiveVideoComponent ],
    entryComponents: [ LiveVideoComponent  ],
})
export class LiveVideoModule { }
